import { ActionTree, Store } from "vuex";
import { DrinkingState } from "./types";
import { IRootState } from "../types";
import { buildAction } from "../utils";
import { mutationNames } from "./mutations";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { Drinks } from "@dcc/types/drinks";
import { DayOfWeek } from "@dcc/types/dayOfWeek";
import { BingeFrequency } from "@dcc/types/bingeFrequency";

export const actionNames = {
  UPDATE_DRINKFREQUENCY: "drinkFrequency",
  UPDATE_MONTHLYDRINKINGDAYS: "monthlyDrinkingDays",
  UPDATE_WEEKLYDRINKINGDAYS: "weeklyDrinkingDays",
  UPDATE_WEEKDAYDRINKQUANTITY: "weekdayDrinkQuantity",
  UPDATE_BINGEFREQUENCY: "updateBingeFrequency",
  UPDATE_AVERAGEDAYDRINKQUANTITY: "averageDayDrinkQuantity",
  UPDATE_TARGETPERCENTAGE: "updateTargetPercentage",
  CLEAR_TARGETPERCENTAGE: "clearTargetPercentage",
  UPDATE_DRINKFREEDAYS: "updateDrinkFreeDays"
};

export interface UpdateDrinkDetails {
  drink: Drinks;
  amount: number;
}

export interface UpdateDrinkForDay extends UpdateDrinkDetails {
  day: DayOfWeek;
}

export const actions: ActionTree<DrinkingState, IRootState> = {
  [actionNames.UPDATE_DRINKFREQUENCY]({ commit }, frequency: DrinkFrequency) {
    commit(mutationNames.UPDATE_DRINKINGFREQ, frequency);
  },
  [actionNames.UPDATE_MONTHLYDRINKINGDAYS]({ commit }, drinkingDays: number) {
    commit(mutationNames.UPDATE_MONTHLYDRINKINGDAYS, drinkingDays);
  },
  [actionNames.UPDATE_WEEKLYDRINKINGDAYS](
    { commit },
    drinkingDays: Readonly<number[]>
  ) {
    commit(mutationNames.UPDATE_WEEKLYDRINKINGDAYS, drinkingDays);
  },
  [actionNames.UPDATE_WEEKDAYDRINKQUANTITY](
    { commit },
    updateDrink: UpdateDrinkForDay
  ) {
    commit(mutationNames.UPDATE_WEEKDAYDRINKQUANTITY, updateDrink);
  },
  [actionNames.UPDATE_BINGEFREQUENCY]({ commit }, frequency: BingeFrequency) {
    commit(mutationNames.UPDATE_BINGEFREQUENCY, frequency);
  },
  [actionNames.UPDATE_AVERAGEDAYDRINKQUANTITY](
    { commit },
    updateDrink: UpdateDrinkDetails
  ) {
    commit(mutationNames.UPDATE_AVERAGEDAYDRINKQUANTITY, updateDrink);
  },
  [actionNames.UPDATE_TARGETPERCENTAGE](
    { commit },
    percentage: number | undefined
  ) {
    commit(mutationNames.UPDATE_TARGETPERCENTAGE, percentage);
  },
  [actionNames.CLEAR_TARGETPERCENTAGE]({ commit }) {
    commit(mutationNames.UPDATE_TARGETPERCENTAGE, undefined);
  },
  [actionNames.UPDATE_DRINKFREEDAYS]({ commit }, days: Readonly<DayOfWeek[]>) {
    commit(mutationNames.UPDATE_DRINKFREEDAYS, days);
  }
};

export const getActions = (store: Store<IRootState>) => ({
  updateDrinkFrequency: buildAction<DrinkFrequency>(
    store,
    "drinking",
    actionNames.UPDATE_DRINKFREQUENCY
  ),
  updateMonthlyDrinkingDays: buildAction<number>(
    store,
    "drinking",
    actionNames.UPDATE_MONTHLYDRINKINGDAYS
  ),
  updateWeeklyDrinkingDays: buildAction<Readonly<number[]>>(
    store,
    "drinking",
    actionNames.UPDATE_WEEKLYDRINKINGDAYS
  ),
  updateWeekdayDrinkQuantity: buildAction<UpdateDrinkForDay>(
    store,
    "drinking",
    actionNames.UPDATE_WEEKDAYDRINKQUANTITY
  ),
  updateBingeFrequency: buildAction<BingeFrequency>(
    store,
    "drinking",
    actionNames.UPDATE_BINGEFREQUENCY
  ),
  updateAverageDayDrinkQuantity: buildAction<UpdateDrinkDetails>(
    store,
    "drinking",
    actionNames.UPDATE_AVERAGEDAYDRINKQUANTITY
  ),
  updateTargetPercentage: buildAction<number | undefined>(
    store,
    "drinking",
    actionNames.UPDATE_TARGETPERCENTAGE
  ),
  clearTargetPercentage: buildAction<void>(
    store,
    "drinking",
    actionNames.CLEAR_TARGETPERCENTAGE
  ),
  updateDrinkFreeDays: buildAction<Readonly<DayOfWeek[]>>(
    store,
    "drinking",
    actionNames.UPDATE_DRINKFREEDAYS
  )
});
